<template>
    <!--
  This example requires some changes to your config:

  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
-->
<!--
  This example requires updating your template:

  ```
  <html class="h-full bg-gray-50">
  <body class="h-full">
  ```
-->
<div class="flex min-h-full flex-col justify-center py-12 sm:px-6 lg:px-8">
  <div class="sm:mx-auto sm:w-full sm:max-w-md">
    <h2 class="mt-6 text-center text-2xl font-bold leading-9 tracking-tight text-brand-blue">Sign in to your account</h2>
  </div>

  <div class="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]">
    <div class="bg-white px-6 py-12 shadow sm:rounded-lg sm:px-12">
        <AlertView :errors="errors"></AlertView>
      <form class="space-y-6" method="POST">
        <div>
          <label for="email" class="block text-sm font-medium leading-6 text-gray-900">Email address</label>
          <div class="mt-2">
            <input v-model="email" id="email" name="email" type="email" autocomplete="email" required class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6">
          </div>
        </div>

        <div>
          <label for="password" class="block text-sm font-medium leading-6 text-gray-900">Password</label>
          <div class="mt-2">
            <input v-model="password" id="password" name="password" type="password" autocomplete="current-password" required class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6">
          </div>
        </div>

        <div class="flex items-center justify-between">
          <div class="flex items-center">
            <input id="remember-me" name="remember-me" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600">
            <label for="remember-me" class="ml-3 block text-sm leading-6 text-gray-900">Remember me</label>
          </div>

          <div class="text-sm leading-6">
            <a href="#" class="font-semibold text-indigo-600 hover:text-indigo-500">Forgot password?</a>
          </div>
        </div>

        <div>
            <AppButton @click="attempt" type="button" width="full">Sign In</AppButton>
        </div>
      </form>
      <p class="mt-10 text-center text-sm text-gray-500">
        Don't have an account?
        <a href="/account/create" class="font-semibold leading-6 text-brand-blue hover:text-indigo-500">Sign up now</a>
      </p>
    </div>

  </div>
</div>

</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            email: null,
            password: null,
            errors: [],
        };
    },
    methods: {
        attempt() {
            this.errors = [];

            axios.post('/api/login', {
                _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                email: this.email,
                password: this.password,
            }).then((response) => {
                window.location.href = this.$urlParams.get('redirect') ?? response.data.redirect;
            }).catch((error) => {
                this.errors.push(error.response.data);
            });
        },
    },
};
</script>

<style lang="scss" scoped>

</style>
